import React, {useEffect, useState} from 'react';
import responsibleMaintenanceService from "../../../../services/web/responsible-maintenance-service.js";
import projectUtils from "../../../../utils/project-utils.js";
import {useQuery} from "@tanstack/react-query";
import {useParams} from "react-router";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {Template} from "../../../../components/template/template.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import Button from "../../../../components/button/button.jsx";
import {Card} from "../../../../components/card/card.jsx";
import {FaPlus} from "react-icons/fa";
import Alert from "../../../../components/alert/alert.jsx";

const ResponsibleMaintenanceForm = () => {
    const {id} = useParams();
    const navigate = navigateHook();

    const [state, setState] = useState(null)

    useEffect(() => {
        return () => setState(null);
    }, []);

    const {data, refetch, isLoading: isLoadingResponsibleMaintenanceService} = useQuery({
        queryFn: () => responsibleMaintenanceService.get(id),
        queryKey: ['responsible-maintenance'],
        enabled: !!id
    });

    const {data: isMaintenanceGroupInUse, isLoading: isLoadingIsMaintenanceGroupInUse} = useQuery({
       queryFn: () => responsibleMaintenanceService.isMaintenanceGroupInUse(id),
       queryKey: ['isAlreadyAssigned'],
       enabled: !!id
    });

    useEffect(() => {
        if (!!id && data) {
            setState(data.name);
        } else  {
            setState(null);
        }
    }, [id, data]);

    const submit = () => {
        if (!state) {
            projectUtils.swalErrorMessage('', translateErrMessage("missing.name"), 'Ok')
            return
        }

        let response;
        if (id) response = responsibleMaintenanceService.edit({id, name: state});
        else response = responsibleMaintenanceService.create({name: state});

        response
            .then((data) => {
                projectUtils.success(!id);

                if (id) {
                    refetch();
                    return;
                }

                const urlDev = `/responsible-maintenance/form/${data}`;
                navigate(urlDev);
            })
            .catch((error) => {
                console.error(error);
                let message = 'Não foi possível salvar.';
                if (error.response.status !== 500) {
                    message = translateErrMessage(error.response.data, message);
                }

                projectUtils.swalErrorMessage('', message, 'Ok');
            })
    }

    const deleteResponsible = () => {
        projectUtils.swalMessage(
            "warning",
            "Excluir",
            `Excluir responsável por manutenção "${state ?? id}"?`,
            "Sim",
            true,
            "Não",
            ({isConfirmed}) => {
                if (isConfirmed) {
                    responsibleMaintenanceService.delete(id)
                        .then(() => {
                            projectUtils.success(true, "Excluído com sucesso");
                            navigate("/responsible-maintenance");
                        })
                        .catch((error) => {
                            console.error(error);
                            let message = 'Não foi possível excluir.';
                            if (error.response.status !== 500) {0
                                message = translateErrMessage(error.response.data, message);
                            }

                            projectUtils.swalErrorMessage('', message, 'Ok')
                        })
                }
            }
        );
    }

    const translateErrMessage = (message, defaultMessage) => {
        const err = {
            "name.already.registered": "Este \"nome\" já está sendo utilizado.",
            "maintenanceGroup.has.role": "Esse responsável por manutenção possui função associada.",
            "missing.name": "O campo \"Nome\" é obrigatório."
        }

        return err[message] ?? defaultMessage
    }

    return (
        <Template isLoading={isLoadingIsMaintenanceGroupInUse || isLoadingResponsibleMaintenanceService}>
            <Template.Header>
                <Template.Title>Responsável por manutenção</Template.Title>

                {
                    id &&
                    <Button target={"default"} onClick={() => navigate("/responsible-maintenance/form")}>
                        <FaPlus /> Adicionar responsável
                    </Button>
                }
            </Template.Header>

            <Template.Body className={"space-y-2"}>
                <Card>
                    <Card.Body>
                        <InputForm
                            id={"name"}
                            label={"Nome *"}
                            value={state}
                            onChange={({target: {value}}) => setState(value)}
                        />
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body className={"flex justify-end gap-2 items-center"}>
                        {
                            id &&
                            <div className="flex justify-end gap-2 w-full items-center">
                                {isMaintenanceGroupInUse &&
                                  <Alert target="warning">Não é possível excluir, pois existem câmeras ou smartcaptures dependentes do responsável.</Alert>
                                }
                                <Button target={"danger"} onClick={deleteResponsible} disabled={isMaintenanceGroupInUse} actionFeedbackType='delete'>

                                    Excluir
                                </Button>
                            </div>
                        }
                        <Button onClick={submit} actionFeedbackType='save'>

                            Salvar
                        </Button>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default ResponsibleMaintenanceForm;